import { LoadingIndicator } from "colbi_web_ui/lib/components";
import { mapProperties } from "colbi_web_ui/lib/utils";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import I18n from "../../I18n";
import styles from "./RareRedirect.module.sass";
import { Buffer } from "buffer";
import jsesc from "jsesc";

const RedirectButton = (props) => {
    const { match, user, fetch } = props;
    const { projectId, locale, fiscalYear } = match.params;
    const { session } = user;
    const i18n = I18n.use(locale);

    const proxyRedirect = fetch.results[`${locale}_proxy_redirect_environment`];
    //Convert session token to base64
    const hexSession = Buffer(session).toString("base64");

    const projectsByOrganization = mapProperties(
        { organizations: "query(0).list", filter: "param(filter)" },
        fetch.results,
        fetch.status,
        RedirectButton.queries(match.params),
        props,
        match.params,
        i18n,
        locale,
    );
    const currentOrganization = (projectsByOrganization.organizations || []).find(({ projects }) =>
        (projects || []).some(({ id }) => id === projectId),
    );

    if (projectId && proxyRedirect && currentOrganization && currentOrganization.id) {
        window.location.href = jsesc(
            `${proxyRedirect}/${currentOrganization.id}/${projectId}/${fiscalYear}/${hexSession}`,
        );
    } else {
        window.location.href = "/";
    }

    return (
        <div className={styles["backdrop"]}>
            <LoadingIndicator className={`${styles["loading-indicator"]}`} />
        </div>
    );
};

RedirectButton.queries = () => [
    {
        resource: "user_projects_organizations",
        body: "id,name,projects{id,name,fiscalYears,status,taxRegistrationNumber,active,projectExpired,modules{navigation_by_import_id,name,default_route,default_module}},organizationExpired, organizationActive",
    },
    {
        resource: "proxy_redirect_environment",
    },
];

export default connect(({ user, fetch }) => ({
    user,
    fetch,
}))(withRouter(RedirectButton));
